












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import EnInvoiceVue from "./EnInvoice.vue"
import EnDayAccountVue from "./EnDayAccount.vue"
import EnOthersVue from "./EnOthers.vue"
import EnSalaryVue from "./EnSalary.vue"
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "invoice-dialog": EnInvoiceVue,
        "others-dialog": EnOthersVue,
        "salary-dialog": EnSalaryVue,
        "dayAccount-dialog": EnDayAccountVue,
    }
})
export default class Envidence extends Vue {
    @Prop({ type: Boolean })
    visible!: boolean;

    @Prop({ type: String, default: "invoice" })
    type!: string;

    @Prop({ type: [Object, Array] })
    data!: Voucher.Voucher[];

    show: boolean = this.visible;

    @Watch("visible")
    visibleChange(val: boolean) {
        this.show = val;
    }

    @Watch("show")
    showChange(val: boolean) {
        this.$emit("update:visible", val);
    }
}
